var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 12,
    viewBox: "0 0 8 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.11307 11.0684C7.16374 11.1191 7.20394 11.1792 7.23137 11.2454C7.25879 11.3116 7.27291 11.3826 7.27291 11.4543C7.27291 11.5259 7.25879 11.5969 7.23137 11.6631C7.20394 11.7293 7.16374 11.7895 7.11307 11.8402C7.06239 11.8908 7.00223 11.931 6.93602 11.9585C6.86981 11.9859 6.79884 12 6.72718 12C6.65551 12 6.58455 11.9859 6.51833 11.9585C6.45212 11.931 6.39196 11.8908 6.34129 11.8402L0.887017 6.38589C0.836305 6.33523 0.796075 6.27508 0.768627 6.20887C0.741179 6.14265 0.727051 6.07168 0.727051 6C0.727051 5.92832 0.741179 5.85735 0.768627 5.79113C0.796075 5.72492 0.836305 5.66476 0.887017 5.61411L6.34129 0.159841C6.44363 0.0574964 6.58244 -2.8531e-09 6.72718 0C6.87191 2.8531e-09 7.01072 0.0574964 7.11307 0.159841C7.21541 0.262185 7.27291 0.400994 7.27291 0.54573C7.27291 0.690467 7.21541 0.829275 7.11307 0.93162L2.044 6L7.11307 11.0684Z",
    fill: "#BCC8D8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/Arrow.f0b05e3615f534055248d113aebe9166.svg";
export { ForwardRef as ReactComponent };